// extracted by mini-css-extract-plugin
export default {"prevVideoArrow":"VideoArrows_prevVideoArrow__dXg8v","nextVideoArrow":"VideoArrows_nextVideoArrow__z+JHB"};